import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import * as dom from '../../../base/browser/dom.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import * as strings from '../../../base/common/strings.js';
import { URI } from '../../../base/common/uri.js';
import { AbstractCodeEditorService } from './abstractCodeEditorService.js';
import { isThemeColor } from '../../common/editorCommon.js';
import { OverviewRulerLane } from '../../common/model.js';
import { IThemeService } from '../../../platform/theme/common/themeService.js';
export var RefCountedStyleSheet = /*#__PURE__*/function () {
  function RefCountedStyleSheet(parent, editorId, styleSheet) {
    _classCallCheck(this, RefCountedStyleSheet);

    this._parent = parent;
    this._editorId = editorId;
    this._styleSheet = styleSheet;
    this._refCount = 0;
  }

  _createClass(RefCountedStyleSheet, [{
    key: "ref",
    value: function ref() {
      this._refCount++;
    }
  }, {
    key: "unref",
    value: function unref() {
      var _a;

      this._refCount--;

      if (this._refCount === 0) {
        (_a = this._styleSheet.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(this._styleSheet);

        this._parent._removeEditorStyleSheets(this._editorId);
      }
    }
  }, {
    key: "insertRule",
    value: function insertRule(rule, index) {
      var sheet = this._styleSheet.sheet;
      sheet.insertRule(rule, index);
    }
  }, {
    key: "removeRulesContainingSelector",
    value: function removeRulesContainingSelector(ruleName) {
      dom.removeCSSRulesContainingSelector(ruleName, this._styleSheet);
    }
  }]);

  return RefCountedStyleSheet;
}();
export var GlobalStyleSheet = /*#__PURE__*/function () {
  function GlobalStyleSheet(styleSheet) {
    _classCallCheck(this, GlobalStyleSheet);

    this._styleSheet = styleSheet;
  }

  _createClass(GlobalStyleSheet, [{
    key: "ref",
    value: function ref() {}
  }, {
    key: "unref",
    value: function unref() {}
  }, {
    key: "insertRule",
    value: function insertRule(rule, index) {
      var sheet = this._styleSheet.sheet;
      sheet.insertRule(rule, index);
    }
  }, {
    key: "removeRulesContainingSelector",
    value: function removeRulesContainingSelector(ruleName) {
      dom.removeCSSRulesContainingSelector(ruleName, this._styleSheet);
    }
  }]);

  return GlobalStyleSheet;
}();

var CodeEditorServiceImpl = /*#__PURE__*/function (_AbstractCodeEditorSe) {
  _inherits(CodeEditorServiceImpl, _AbstractCodeEditorSe);

  var _super = _createSuper(CodeEditorServiceImpl);

  function CodeEditorServiceImpl(themeService) {
    var _this;

    var styleSheet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, CodeEditorServiceImpl);

    _this = _super.call(this);
    _this._decorationOptionProviders = new Map();
    _this._editorStyleSheets = new Map();
    _this._globalStyleSheet = styleSheet ? styleSheet : null;
    _this._themeService = themeService;
    return _this;
  }

  _createClass(CodeEditorServiceImpl, [{
    key: "_getOrCreateGlobalStyleSheet",
    value: function _getOrCreateGlobalStyleSheet() {
      if (!this._globalStyleSheet) {
        this._globalStyleSheet = new GlobalStyleSheet(dom.createStyleSheet());
      }

      return this._globalStyleSheet;
    }
  }, {
    key: "_getOrCreateStyleSheet",
    value: function _getOrCreateStyleSheet(editor) {
      if (!editor) {
        return this._getOrCreateGlobalStyleSheet();
      }

      var domNode = editor.getContainerDomNode();

      if (!dom.isInShadowDOM(domNode)) {
        return this._getOrCreateGlobalStyleSheet();
      }

      var editorId = editor.getId();

      if (!this._editorStyleSheets.has(editorId)) {
        var refCountedStyleSheet = new RefCountedStyleSheet(this, editorId, dom.createStyleSheet(domNode));

        this._editorStyleSheets.set(editorId, refCountedStyleSheet);
      }

      return this._editorStyleSheets.get(editorId);
    }
  }, {
    key: "_removeEditorStyleSheets",
    value: function _removeEditorStyleSheets(editorId) {
      this._editorStyleSheets.delete(editorId);
    }
  }, {
    key: "registerDecorationType",
    value: function registerDecorationType(key, options, parentTypeKey, editor) {
      var provider = this._decorationOptionProviders.get(key);

      if (!provider) {
        var styleSheet = this._getOrCreateStyleSheet(editor);

        var providerArgs = {
          styleSheet: styleSheet,
          key: key,
          parentTypeKey: parentTypeKey,
          options: options || Object.create(null)
        };

        if (!parentTypeKey) {
          provider = new DecorationTypeOptionsProvider(this._themeService, styleSheet, providerArgs);
        } else {
          provider = new DecorationSubTypeOptionsProvider(this._themeService, styleSheet, providerArgs);
        }

        this._decorationOptionProviders.set(key, provider);
      }

      provider.refCount++;
    }
  }, {
    key: "removeDecorationType",
    value: function removeDecorationType(key) {
      var provider = this._decorationOptionProviders.get(key);

      if (provider) {
        provider.refCount--;

        if (provider.refCount <= 0) {
          this._decorationOptionProviders.delete(key);

          provider.dispose();
          this.listCodeEditors().forEach(function (ed) {
            return ed.removeDecorations(key);
          });
        }
      }
    }
  }, {
    key: "resolveDecorationOptions",
    value: function resolveDecorationOptions(decorationTypeKey, writable) {
      var provider = this._decorationOptionProviders.get(decorationTypeKey);

      if (!provider) {
        throw new Error('Unknown decoration type key: ' + decorationTypeKey);
      }

      return provider.getOptions(this, writable);
    }
  }]);

  return CodeEditorServiceImpl;
}(AbstractCodeEditorService);

CodeEditorServiceImpl = __decorate([__param(0, IThemeService)], CodeEditorServiceImpl);
export { CodeEditorServiceImpl };

var DecorationSubTypeOptionsProvider = /*#__PURE__*/function () {
  function DecorationSubTypeOptionsProvider(themeService, styleSheet, providerArgs) {
    _classCallCheck(this, DecorationSubTypeOptionsProvider);

    this._styleSheet = styleSheet;

    this._styleSheet.ref();

    this._parentTypeKey = providerArgs.parentTypeKey;
    this.refCount = 0;
    this._beforeContentRules = new DecorationCSSRules(3
    /* BeforeContentClassName */
    , providerArgs, themeService);
    this._afterContentRules = new DecorationCSSRules(4
    /* AfterContentClassName */
    , providerArgs, themeService);
  }

  _createClass(DecorationSubTypeOptionsProvider, [{
    key: "getOptions",
    value: function getOptions(codeEditorService, writable) {
      var options = codeEditorService.resolveDecorationOptions(this._parentTypeKey, true);

      if (this._beforeContentRules) {
        options.beforeContentClassName = this._beforeContentRules.className;
      }

      if (this._afterContentRules) {
        options.afterContentClassName = this._afterContentRules.className;
      }

      return options;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._beforeContentRules) {
        this._beforeContentRules.dispose();

        this._beforeContentRules = null;
      }

      if (this._afterContentRules) {
        this._afterContentRules.dispose();

        this._afterContentRules = null;
      }

      this._styleSheet.unref();
    }
  }]);

  return DecorationSubTypeOptionsProvider;
}();

var DecorationTypeOptionsProvider = /*#__PURE__*/function () {
  function DecorationTypeOptionsProvider(themeService, styleSheet, providerArgs) {
    var _this2 = this;

    _classCallCheck(this, DecorationTypeOptionsProvider);

    this._disposables = new DisposableStore();
    this._styleSheet = styleSheet;

    this._styleSheet.ref();

    this.refCount = 0;

    var createCSSRules = function createCSSRules(type) {
      var rules = new DecorationCSSRules(type, providerArgs, themeService);

      _this2._disposables.add(rules);

      if (rules.hasContent) {
        return rules.className;
      }

      return undefined;
    };

    var createInlineCSSRules = function createInlineCSSRules(type) {
      var rules = new DecorationCSSRules(type, providerArgs, themeService);

      _this2._disposables.add(rules);

      if (rules.hasContent) {
        return {
          className: rules.className,
          hasLetterSpacing: rules.hasLetterSpacing
        };
      }

      return null;
    };

    this.className = createCSSRules(0
    /* ClassName */
    );
    var inlineData = createInlineCSSRules(1
    /* InlineClassName */
    );

    if (inlineData) {
      this.inlineClassName = inlineData.className;
      this.inlineClassNameAffectsLetterSpacing = inlineData.hasLetterSpacing;
    }

    this.beforeContentClassName = createCSSRules(3
    /* BeforeContentClassName */
    );
    this.afterContentClassName = createCSSRules(4
    /* AfterContentClassName */
    );
    this.glyphMarginClassName = createCSSRules(2
    /* GlyphMarginClassName */
    );
    var options = providerArgs.options;
    this.isWholeLine = Boolean(options.isWholeLine);
    this.stickiness = options.rangeBehavior;
    var lightOverviewRulerColor = options.light && options.light.overviewRulerColor || options.overviewRulerColor;
    var darkOverviewRulerColor = options.dark && options.dark.overviewRulerColor || options.overviewRulerColor;

    if (typeof lightOverviewRulerColor !== 'undefined' || typeof darkOverviewRulerColor !== 'undefined') {
      this.overviewRuler = {
        color: lightOverviewRulerColor || darkOverviewRulerColor,
        darkColor: darkOverviewRulerColor || lightOverviewRulerColor,
        position: options.overviewRulerLane || OverviewRulerLane.Center
      };
    }
  }

  _createClass(DecorationTypeOptionsProvider, [{
    key: "getOptions",
    value: function getOptions(codeEditorService, writable) {
      if (!writable) {
        return this;
      }

      return {
        inlineClassName: this.inlineClassName,
        beforeContentClassName: this.beforeContentClassName,
        afterContentClassName: this.afterContentClassName,
        className: this.className,
        glyphMarginClassName: this.glyphMarginClassName,
        isWholeLine: this.isWholeLine,
        overviewRuler: this.overviewRuler,
        stickiness: this.stickiness
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._disposables.dispose();

      this._styleSheet.unref();
    }
  }]);

  return DecorationTypeOptionsProvider;
}();

var _CSS_MAP = {
  color: 'color:{0} !important;',
  opacity: 'opacity:{0};',
  backgroundColor: 'background-color:{0};',
  outline: 'outline:{0};',
  outlineColor: 'outline-color:{0};',
  outlineStyle: 'outline-style:{0};',
  outlineWidth: 'outline-width:{0};',
  border: 'border:{0};',
  borderColor: 'border-color:{0};',
  borderRadius: 'border-radius:{0};',
  borderSpacing: 'border-spacing:{0};',
  borderStyle: 'border-style:{0};',
  borderWidth: 'border-width:{0};',
  fontStyle: 'font-style:{0};',
  fontWeight: 'font-weight:{0};',
  textDecoration: 'text-decoration:{0};',
  cursor: 'cursor:{0};',
  letterSpacing: 'letter-spacing:{0};',
  gutterIconPath: 'background:{0} center center no-repeat;',
  gutterIconSize: 'background-size:{0};',
  contentText: 'content:\'{0}\';',
  contentIconPath: 'content:{0};',
  margin: 'margin:{0};',
  width: 'width:{0};',
  height: 'height:{0};'
};

var DecorationCSSRules = /*#__PURE__*/function () {
  function DecorationCSSRules(ruleType, providerArgs, themeService) {
    var _this3 = this;

    _classCallCheck(this, DecorationCSSRules);

    this._theme = themeService.getColorTheme();
    this._ruleType = ruleType;
    this._providerArgs = providerArgs;
    this._usesThemeColors = false;
    this._hasContent = false;
    this._hasLetterSpacing = false;
    var className = CSSNameHelper.getClassName(this._providerArgs.key, ruleType);

    if (this._providerArgs.parentTypeKey) {
      className = className + ' ' + CSSNameHelper.getClassName(this._providerArgs.parentTypeKey, ruleType);
    }

    this._className = className;
    this._unThemedSelector = CSSNameHelper.getSelector(this._providerArgs.key, this._providerArgs.parentTypeKey, ruleType);

    this._buildCSS();

    if (this._usesThemeColors) {
      this._themeListener = themeService.onDidColorThemeChange(function (theme) {
        _this3._theme = themeService.getColorTheme();

        _this3._removeCSS();

        _this3._buildCSS();
      });
    } else {
      this._themeListener = null;
    }
  }

  _createClass(DecorationCSSRules, [{
    key: "dispose",
    value: function dispose() {
      if (this._hasContent) {
        this._removeCSS();

        this._hasContent = false;
      }

      if (this._themeListener) {
        this._themeListener.dispose();

        this._themeListener = null;
      }
    }
  }, {
    key: "hasContent",
    get: function get() {
      return this._hasContent;
    }
  }, {
    key: "hasLetterSpacing",
    get: function get() {
      return this._hasLetterSpacing;
    }
  }, {
    key: "className",
    get: function get() {
      return this._className;
    }
  }, {
    key: "_buildCSS",
    value: function _buildCSS() {
      var options = this._providerArgs.options;
      var unthemedCSS, lightCSS, darkCSS;

      switch (this._ruleType) {
        case 0
        /* ClassName */
        :
          unthemedCSS = this.getCSSTextForModelDecorationClassName(options);
          lightCSS = this.getCSSTextForModelDecorationClassName(options.light);
          darkCSS = this.getCSSTextForModelDecorationClassName(options.dark);
          break;

        case 1
        /* InlineClassName */
        :
          unthemedCSS = this.getCSSTextForModelDecorationInlineClassName(options);
          lightCSS = this.getCSSTextForModelDecorationInlineClassName(options.light);
          darkCSS = this.getCSSTextForModelDecorationInlineClassName(options.dark);
          break;

        case 2
        /* GlyphMarginClassName */
        :
          unthemedCSS = this.getCSSTextForModelDecorationGlyphMarginClassName(options);
          lightCSS = this.getCSSTextForModelDecorationGlyphMarginClassName(options.light);
          darkCSS = this.getCSSTextForModelDecorationGlyphMarginClassName(options.dark);
          break;

        case 3
        /* BeforeContentClassName */
        :
          unthemedCSS = this.getCSSTextForModelDecorationContentClassName(options.before);
          lightCSS = this.getCSSTextForModelDecorationContentClassName(options.light && options.light.before);
          darkCSS = this.getCSSTextForModelDecorationContentClassName(options.dark && options.dark.before);
          break;

        case 4
        /* AfterContentClassName */
        :
          unthemedCSS = this.getCSSTextForModelDecorationContentClassName(options.after);
          lightCSS = this.getCSSTextForModelDecorationContentClassName(options.light && options.light.after);
          darkCSS = this.getCSSTextForModelDecorationContentClassName(options.dark && options.dark.after);
          break;

        default:
          throw new Error('Unknown rule type: ' + this._ruleType);
      }

      var sheet = this._providerArgs.styleSheet;
      var hasContent = false;

      if (unthemedCSS.length > 0) {
        sheet.insertRule("".concat(this._unThemedSelector, " {").concat(unthemedCSS, "}"), 0);
        hasContent = true;
      }

      if (lightCSS.length > 0) {
        sheet.insertRule(".vs".concat(this._unThemedSelector, " {").concat(lightCSS, "}"), 0);
        hasContent = true;
      }

      if (darkCSS.length > 0) {
        sheet.insertRule(".vs-dark".concat(this._unThemedSelector, ", .hc-black").concat(this._unThemedSelector, " {").concat(darkCSS, "}"), 0);
        hasContent = true;
      }

      this._hasContent = hasContent;
    }
  }, {
    key: "_removeCSS",
    value: function _removeCSS() {
      this._providerArgs.styleSheet.removeRulesContainingSelector(this._unThemedSelector);
    }
    /**
     * Build the CSS for decorations styled via `className`.
     */

  }, {
    key: "getCSSTextForModelDecorationClassName",
    value: function getCSSTextForModelDecorationClassName(opts) {
      if (!opts) {
        return '';
      }

      var cssTextArr = [];
      this.collectCSSText(opts, ['backgroundColor'], cssTextArr);
      this.collectCSSText(opts, ['outline', 'outlineColor', 'outlineStyle', 'outlineWidth'], cssTextArr);
      this.collectBorderSettingsCSSText(opts, cssTextArr);
      return cssTextArr.join('');
    }
    /**
     * Build the CSS for decorations styled via `inlineClassName`.
     */

  }, {
    key: "getCSSTextForModelDecorationInlineClassName",
    value: function getCSSTextForModelDecorationInlineClassName(opts) {
      if (!opts) {
        return '';
      }

      var cssTextArr = [];
      this.collectCSSText(opts, ['fontStyle', 'fontWeight', 'textDecoration', 'cursor', 'color', 'opacity', 'letterSpacing'], cssTextArr);

      if (opts.letterSpacing) {
        this._hasLetterSpacing = true;
      }

      return cssTextArr.join('');
    }
    /**
     * Build the CSS for decorations styled before or after content.
     */

  }, {
    key: "getCSSTextForModelDecorationContentClassName",
    value: function getCSSTextForModelDecorationContentClassName(opts) {
      if (!opts) {
        return '';
      }

      var cssTextArr = [];

      if (typeof opts !== 'undefined') {
        this.collectBorderSettingsCSSText(opts, cssTextArr);

        if (typeof opts.contentIconPath !== 'undefined') {
          cssTextArr.push(strings.format(_CSS_MAP.contentIconPath, dom.asCSSUrl(URI.revive(opts.contentIconPath))));
        }

        if (typeof opts.contentText === 'string') {
          var truncated = opts.contentText.match(/^.*$/m)[0]; // only take first line

          var escaped = truncated.replace(/['\\]/g, '\\$&');
          cssTextArr.push(strings.format(_CSS_MAP.contentText, escaped));
        }

        this.collectCSSText(opts, ['fontStyle', 'fontWeight', 'textDecoration', 'color', 'opacity', 'backgroundColor', 'margin'], cssTextArr);

        if (this.collectCSSText(opts, ['width', 'height'], cssTextArr)) {
          cssTextArr.push('display:inline-block;');
        }
      }

      return cssTextArr.join('');
    }
    /**
     * Build the CSS for decorations styled via `glpyhMarginClassName`.
     */

  }, {
    key: "getCSSTextForModelDecorationGlyphMarginClassName",
    value: function getCSSTextForModelDecorationGlyphMarginClassName(opts) {
      if (!opts) {
        return '';
      }

      var cssTextArr = [];

      if (typeof opts.gutterIconPath !== 'undefined') {
        cssTextArr.push(strings.format(_CSS_MAP.gutterIconPath, dom.asCSSUrl(URI.revive(opts.gutterIconPath))));

        if (typeof opts.gutterIconSize !== 'undefined') {
          cssTextArr.push(strings.format(_CSS_MAP.gutterIconSize, opts.gutterIconSize));
        }
      }

      return cssTextArr.join('');
    }
  }, {
    key: "collectBorderSettingsCSSText",
    value: function collectBorderSettingsCSSText(opts, cssTextArr) {
      if (this.collectCSSText(opts, ['border', 'borderColor', 'borderRadius', 'borderSpacing', 'borderStyle', 'borderWidth'], cssTextArr)) {
        cssTextArr.push(strings.format('box-sizing: border-box;'));
        return true;
      }

      return false;
    }
  }, {
    key: "collectCSSText",
    value: function collectCSSText(opts, properties, cssTextArr) {
      var lenBefore = cssTextArr.length;

      var _iterator = _createForOfIteratorHelper(properties),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          var value = this.resolveValue(opts[property]);

          if (typeof value === 'string') {
            cssTextArr.push(strings.format(_CSS_MAP[property], value));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return cssTextArr.length !== lenBefore;
    }
  }, {
    key: "resolveValue",
    value: function resolveValue(value) {
      if (isThemeColor(value)) {
        this._usesThemeColors = true;

        var color = this._theme.getColor(value.id);

        if (color) {
          return color.toString();
        }

        return 'transparent';
      }

      return value;
    }
  }]);

  return DecorationCSSRules;
}();

var CSSNameHelper = /*#__PURE__*/function () {
  function CSSNameHelper() {
    _classCallCheck(this, CSSNameHelper);
  }

  _createClass(CSSNameHelper, null, [{
    key: "getClassName",
    value: function getClassName(key, type) {
      return 'ced-' + key + '-' + type;
    }
  }, {
    key: "getSelector",
    value: function getSelector(key, parentKey, ruleType) {
      var selector = '.monaco-editor .' + this.getClassName(key, ruleType);

      if (parentKey) {
        selector = selector + '.' + this.getClassName(parentKey, ruleType);
      }

      if (ruleType === 3
      /* BeforeContentClassName */
      ) {
        selector += '::before';
      } else if (ruleType === 4
      /* AfterContentClassName */
      ) {
        selector += '::after';
      }

      return selector;
    }
  }]);

  return CSSNameHelper;
}();